import React from "react";
import { Form } from "react-bootstrap";

function Summery_holder_order({ cartData, allPrice }) {
  return (
    <>
      <section className="Summery_section_holder">
        <div className="summery_holder">
          {/* <div className="content_box_holder mt-3">
            <div className="heading_strip_holder">
              <div className="content_strip_holder">
                <h1>Subtotal</h1>
                <h1>₹ {allPrice?.totalCalculations?.totalSellingPrice}</h1>
              </div>
            </div>
          </div> */}

          <div className="content_box_holder mt-3">
            <div className="heading_strip_holder">
              <div className="content_strip_holder">
                <h1>Subtotal</h1>
                <h1>₹ {Number(allPrice?.totalCalculations?.totalSellingPrice).toFixed(2)}</h1>
              </div>
            </div>
          </div>
          <div className="content_box_holder mt-3">
            <div className="heading_strip_holder">
              <div className="content_strip_holder">
                <h1>Gift Wrap Price</h1>
                <h1>₹ {Number(allPrice?.totalCalculations?.totalCustomizePrice).toFixed(2)}</h1>
              </div>
            </div>
          </div>
          <div className="content_box_holder mt-3">
            <div className="heading_strip_holder">
              <div className="content_strip_holder">
                <h1>Customise Price</h1>
                <h1>₹ {Number(allPrice?.totalCalculations?.totalDileveryCharges).toFixed(2)}</h1>
              </div>
            </div>
          </div>
          <div className="content_box_holder mt-3">
            <div className="heading_strip_holder">
              <div className="content_strip_holder">
                <h1>Total Tax</h1>
                <h1>₹ {Number(allPrice?.totalCalculations?.totalTax).toFixed(2)}</h1>
              </div>
            </div>
          </div>

          <div className="content_box_holder mt-3">
            <div className="heading_strip_holder">
              <div className="content_strip_holder">
                <h1>Total</h1>
                <h1>₹ {Number(allPrice?.totalCalculations?.totalAmount).toFixed(2)}</h1>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="content_box_holder mt-3">
          <div className="heading_strip_holder">
            <h1>Add Gift Wrapping</h1>
            <hr />
          </div>

          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="Select this to have your product beautifully gift-wrapped."
            />
          </Form.Group>
        </div> */}

        <div className="content_box_holder mt-3">
          <div className="heading_strip_holder">
            <h1>Customer Service</h1>
            <hr />
          </div>

          <p>Monday to Saturday 10:00 am - 06:00 pm IST, </p>
          <p>+91 731 6711 800 </p>
          <p>+91 93029 11233</p>

          <hr />

          <div className="delivery_policy_holder">
            <div className="row">
              <div className="col-md-4 col-sm-4 col-4">
                <div className="delivery_holder">
                  <div className="img_holder">
                    <img
                      src="/assest/luxury_images/cart/fast-delivery.png"
                      alt=""
                      className="delivery_img"
                    />
                  </div>
                  <p>Free standard delivery</p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-4">
                <div className="delivery_holder">
                  <div className="img_holder">
                    <img
                      src="/assest/luxury_images/cart/exchange.png"
                      alt=""
                      className="delivery_img"
                    />
                  </div>
                  <p>Exchanges</p>
                </div>
              </div>

              <div className="col-md-4 col-sm-4 col-4">
                <div className="delivery_holder">
                  <div className="img_holder">
                    <img
                      src="/assest/luxury_images/cart/shopping.png"
                      alt=""
                      className="delivery_img"
                    />
                  </div>
                  <p>Shop Securely</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Summery_holder_order;
